import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { meusPedidos } from '../services/api';

const STATUS_LABEL = { aguardando: '⏳ Aguardando', aceito: '✅ Aceito', preparo: '🔥 Em preparo', pronto: '🎉 Pronto!', entregando: '🛵 Saiu para entrega', entregue: '🏁 Entregue', cancelado: '❌ Cancelado' };
const STATUS_CLASS = { aguardando: 'chip-aguardando', aceito: 'chip-aceito', preparo: 'chip-preparo', pronto: 'chip-pronto', entregando: 'chip-entregando', entregue: 'chip-entregue', cancelado: 'chip-preparo' };

export default function MeusPedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    meusPedidos().then(r => setPedidos(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 16 }}><h2>📦 Meus Pedidos</h2><div className="spinner" /></div>;

  if (!pedidos.length) return (
    <div style={{ padding: 16 }}>
      <h2>📦 Meus Pedidos</h2>
      <div className="empty-state">
        <div className="icon">📦</div>
        <h3>Nenhum pedido ainda</h3>
        <p>Faça seu primeiro pedido!</p>
        <button className="btn-primary" style={{ marginTop: 16, width: 'auto', padding: '12px 24px' }} onClick={() => navigate('/')}>Ver cardápio</button>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 16 }}>
      <h2>📦 Meus Pedidos</h2>
      {pedidos.map(p => (
        <div key={p.id} onClick={() => navigate(`/pedidos/${p.id}`)} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 14, marginBottom: 8, cursor: 'pointer' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14 }}>Pedido #{p.id}</div>
              <div style={{ fontSize: 11, color: 'var(--text2)' }}>{new Date(p.criado_em).toLocaleString('pt-BR')}</div>
            </div>
            <span className={`chip ${STATUS_CLASS[p.status] || 'chip-aguardando'}`}>{STATUS_LABEL[p.status] || p.status}</span>
          </div>
          <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 6 }}>{p.itens_resumo}</div>
          <div style={{ fontWeight: 800, color: 'var(--orange)' }}>R$ {parseFloat(p.total).toFixed(2).replace('.', ',')}</div>
        </div>
      ))}
    </div>
  );
}
